import { CouponType } from '@thurstech/commons/dist/entity/coupon';
import * as yup from 'yup';

export const addCouponSchema = yup.object({
  id: yup.string(),
  type: yup.string().required('Coupon Type is Required').oneOf(Object.values(CouponType)),
  code: yup.string().required('Code is required'),
  description: yup.string(),
  minimumOrder: yup.number(),
  expiry: yup.date().required('Expiry Date is required').min(new Date()),
  discount: yup.number().when('type', {
    is: CouponType.FIXED,
    then: schema => schema.required('Discount is required'),
    otherwise: schema => schema.notRequired()
  }),
  percent: yup.number().when('type', {
    is: CouponType.PERCENT,
    then: schema => schema.required('Discount Percentage is required').min(1).max(100),
    otherwise: schema => schema.notRequired()
  }),
  maxDiscount: yup.number().when('type', {
    is: CouponType.PERCENT,
    // then: schema => schema.required(),
    otherwise: schema => schema.notRequired()
  })
});

export type AddCouponFormData = yup.InferType<typeof addCouponSchema>;
